import { baseUrl } from "@/services/constants.js";
import axios from "axios";

export default {
    namespaced: true,

    state: {
        threndingIdeas: [],
        myIdeas: [],
        allIdeas: [],
        dialog: false,
        editedIdea: {
            _id: null,
            title: "",
            description: "",
            user: null,
            approved: false,
            upVote: 0,
            downVote: 0,
            hasVoted: false
        },
        defaultIdea: {
            _id: null,
            title: "",
            description: "",
            user: null,
            approved: false,
            upVote: 0,
            downVote: 0,
            hasVoted: false
        }
    },

    getters: {
        _getAllIdeas: state => {
            return state.threndingIdeas
        },
        _getMyIdeas: state => {
            return state.myIdeas
        }
    },

    mutations: {
        setThrendingIdeas(state, ideaList) {
            state.threndingIdeas = ideaList
        },
        setMyIdeas(state, ideaList) {
            state.myIdeas = ideaList
        },
        setAllIdeas(state, allIdeas) {
            state.allIdeas = allIdeas
        },
        createNewIdea(state, idea) {
            state.myIdeas.push(idea)
        },
        deleteIdea(state, ideaId) {
            var idx = state.myIdeas.findIndex(x => x._id === ideaId);
            state.myIdeas.splice(idx, 1);
        },
        updateIdea(state, idea) {
            // idea.map(i => state.myIdeas.find(j => j._id === i._id) || i);
            var idx = state.myIdeas.findIndex(x => x._id === idea._id);
            state.myIdeas[idx].description = idea.description
            state.myIdeas[idx].title = idea.title
        },
        setDialog(state, val) {
            state.dialog = val
        },
        setEditedIdea(state, idea) {
            state.editedIdea = Object.assign({}, idea)
        },
        clearEditedIdea(state) {
            state.editedIdea = Object.assign({}, state.defaultIdea)
        },
        vote(state, payload) {
            var idx = state.allIdeas.findIndex(x => x._id === payload.idea);

            if (payload.vote == true) {
                if (state.allIdeas[idx].downVote > 0) {
                    state.allIdeas[idx].downVote -= 1
                }
                state.allIdeas[idx].upVote += 1;
            } else if (payload.vote == false) {
                if (state.allIdeas[idx].upVote > 0) {
                    state.allIdeas[idx].upVote -= 1;
                }
                state.allIdeas[idx].downVote += 1
            } else {
                if (state.allIdeas[idx].downVote > 0) {
                    state.allIdeas[idx].downVote -= 1
                }
                if (state.allIdeas[idx].upVote > 0) {
                    state.allIdeas[idx].upVote -= 1;
                }

            }
            state.allIdeas[idx].vote = payload.vote;

        }
    },

    actions: {
        async getAllThrendingIdeas({ commit }) {
            try {
                const resp = await axios.get(baseUrl + "ideas?sort=-upVote&limit=10")
                if (resp != null) {
                    commit("setThrendingIdeas", resp.data.data.ideas)
                }
            } catch (e) {
                // show error message
            }
        },
        async getAllMyIdeas({ commit }, userId) {
            try {
                const resp = await axios.get(baseUrl + "ideas?user=" + userId)
                if (resp != null) {
                    commit('setMyIdeas', resp.data.data.ideas)
                };
            }
            catch (e) {
            }
        },
        async getAllIdeas({ commit }) {

            try {
                const resp = await axios.get(baseUrl + "ideas")
                if (resp != null) {
                    commit("setAllIdeas", resp.data.data.ideas)
                }

            } catch (e) {
                // show error message
            }
        },
        async searchIdea() {
            try {
                let q = "Auto Solar Tracker"
                const r = await axios.get(baseUrl + "ideas?title=" + q)
                if (resp != null) {
                    // Creation comfirmation
                    // commit("setMyIdeas", resp.data.data.ideas)
                    // commit("setAllIdeas", resp.data.data.ideas)
                }

            } catch (e) {
                // show error message
            }
        },
        async create({ commit }, data) {
            if (data._id) {
                // Update existing idea
                try {
                    const resp = await axios.patch(baseUrl + "ideas/" + data._id, { title: data.title, description: data.description })
                    if (resp != null) {
                        commit("updateIdea", data)
                        commit("notification", { status: true, text: "Idea Updated Successfuly!", color: "cyan darken-2" }, { root: true })
                    }
                } catch (e) {
                    // show error message
                    commit("notification", { status: true, text: "Idea Update Failed!", color: "error darken-2" }, { root: true })
                }
            } else {
                // Create new Idea
                try {
                    const resp = await axios.post(baseUrl + "ideas", data)
                    if (resp != null && resp.statusCode == 200) {
                        commit("createNewIdea", data)
                        commit("notification", { status: true, text: "Idea Created Successfuly!", color: "cyan darken-2" }, { root: true })

                    }
                } catch (e) {
                    // show error message
                    commit("notification", { status: true, text: "Idea Creation Failed!", color: "error darken-2" }, { root: true })

                }
            }
        },
        async remove({ commit }, id) {
            try {
                const resp = await axios.delete(baseUrl + "ideas/" + id)
                if (resp != null) {
                    // Deletion comfirmation
                    commit('deleteIdea', id)
                    commit("notification", { status: true, text: "Idea Deleted Successfuly!", color: "cyan darken-2" }, { root: true })
                }
            } catch (e) {
                // show error message
                commit("notification", { status: true, text: "Unable to Delete Idea!", color: "error darken-2" }, { root: true })

            }
        },
        async vote({ commit }, payload) {
            /*
            Assuming payload as {id: "_ideaid", vote: "Boolean ?null"}
             */
            if (payload.hasVoted == null) {
                try {
                    const resp = await axios.post(baseUrl + "ideas/" + payload.id + "/polls", { vote: payload.vote })
                    if (resp != null) {
                        // Initially, before any vote

                        commit('vote', resp.data.data.doc)
                    }
                } catch (e) {
                    // show error message
                }
            } else {
                if (payload.vote == null) {
                    try {
                        const resp = await axios.delete(baseUrl + "ideas/" + payload.id + "/polls/" + payload.poll_id)
                        if (resp != null) {
                            // Deleting vote [removing]

                            commit('vote', resp.data.data.doc)
                        }
                    } catch (e) {
                        // show error message
                    }
                } else {
                    try {
                        const resp = await axios.patch(baseUrl + "ideas/" + payload.id + "/polls/" + payload.poll_id, { vote: payload.vote })
                        if (resp != null) {
                            // voting up or down
                            commit('vote', resp.data.data.doc)
                        }
                    } catch (e) {
                        // show error message
                    }
                }

            }
        }



    }
}